/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import ourwork from '../vendors/our-work';
import postGrid from '../vendors/post-grid';
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import slick from '../vendors/slick.min';
// import GSAP from '../vendors/gsap.min';
// import SplitText from '../vendors/SplitText.min';
import ScrollTrigger from '../vendors/ScrollTrigger.min';
import ScrollSmoother from '../vendors/ScrollSmoother.min';
import ScrollToPlugin from '../vendors/ScrollToPlugin.min';
import Cursor from '../vendors/cursorjs.min';
import Splide from '../vendors/splide.min';
import SplideExtension from '../vendors/splide-extension-auto-scroll.min';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

jQuery( function() {
	/**
	 *
	 * Script for Tags
	 *
	 */
	jQuery( '.seo-slider-block,.gallery-slider-block' ).closest( 'section' ).css( 'overflow-x', 'clip' );

	jQuery( '.iat-columns' ).each( function() {
		const textBlock = jQuery( this ).find( '.iat-text' );
		const imageBlock = jQuery( this ).find( '.iat-image' );

		if ( imageBlock.index() > textBlock.index() ) {
			jQuery( this ).addClass( 'image-at-top' );
		}
	} );

	/**
	 *
	 * Script for Tags
	 *
	 */

	// function checkAndModifyTags() {
	// 	if ( jQuery( window ).width() < 2500 ) {
	// 		jQuery( '.post-box .post-tag' ).each( function() {
	// 			const spans = jQuery( this ).find( 'span' );
	// 			if ( spans.length > 1 ) {
	// 				const hiddenCount = spans.length - 1;
	// 				spans.slice( 1 ).hide();
	// 				if ( ! jQuery( this ).find( '.count' ).length ) {
	// 					jQuery( this ).append( '<span class="count">+' + hiddenCount + '</span>' );
	// 				} else {
	// 					jQuery( this ).find( '.count' ).text( '+' + hiddenCount );
	// 				}
	// 			}
	// 		} );
	// 	} else {
	// 		jQuery( '.post-tag' ).each( function() {
	// 			jQuery( this ).find( 'span' ).show();
	// 			jQuery( this ).find( '.count' ).remove();
	// 		} );
	// 	}
	// }

	// checkAndModifyTags();

	// jQuery( window ).resize( function() {
	// 	checkAndModifyTags();
	// } );

	/**
	 * Header Wrapper Height Calculation for Navigation Overlay
	 */

	if ( jQuery( '.header-wrapper' ).length > 0 ) {
		function updateHeaderHeight() {
			jQuery( '.header-wrapper' ).each( function() {
				jQuery( this ).css( '--em_header-wrapper-default', jQuery( this ).outerHeight() + 'px' );
			} );
		}
		updateHeaderHeight();
		jQuery( window ).resize( updateHeaderHeight );
	}

	/**
	 * Toggle menu for mobile
	 */

	const navOverlay = jQuery( '.nav-overlay' );
	const htmlBody = jQuery( 'html, body' );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		navOverlay.toggleClass( 'open' );
		htmlBody.toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	jQuery( '.menu-item-has-children > a:first-child' ).each( function() {
		jQuery( this ).after( '<span class="submenu-icon"></span>' );
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav' ).on( 'click', '.submenu-icon', function() {
		const parentLi = jQuery( this ).closest( 'li' );

		parentLi.siblings( '.active' )
			.removeClass( 'active' )
			.find( 'ul' ).slideUp();

		parentLi.toggleClass( 'active' ).find( 'ul' ).stop( true, true ).slideToggle();
		parentLi.parents( 'ul' ).toggleClass( 'disabled-menu', parentLi.hasClass( 'active' ) );
	} );

	/**
	 *  Accessibility for Simple menu & Mega menu
	 */

	jQuery( '.menu-item-has-children > a' ).on( 'focus blur', function( event ) {
		jQuery( this ).siblings( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	jQuery( '.sub-menu a, .mega-menu a' ).on( 'focus blur', function( event ) {
		jQuery( this ).closest( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	/**
	 * Script for Accessibility of html Tags
	 */

	jQuery( 'h1, h2, h3, h4, h5, h6,p,li,blockquote,cite,strong,dt,dd,th,td,b,i,u,s,em,small,sup,del,ins,abbr,mark,details,pre,kbd,samp,var,address,code,q,figure,figcaption,caption,.top-bar-text,.top-bar-cross,.copy-right,.post-author-img,.post-author-name,.post-meta-date,.post-date' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );

	jQuery( '.header-nav li, .blog-nav li, .footer-nav li, .legal-nav li' ).each( function() {
		const link = jQuery( this ).find( 'a' );
		if ( link.length > 0 ) {
			jQuery( this ).removeAttr( 'tabindex' );
		} else {
			jQuery( this ).attr( 'tabindex', '0' );
		}
	} );

	jQuery( 'form p' ).each( function() {
		jQuery( this ).removeAttr( 'tabindex' );
	} );

	jQuery( 'a,button:not([href])' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );

	autosize();

	function autosize() {
		const text = jQuery( 'textarea' );

		text.each( function() {
			jQuery( this ).attr( 'rows', 5 );
			resize( jQuery( this ) );
		} );

		text.on( 'input', function() {
			resize( jQuery( this ) );
		} );

		function resize( $text ) {
			$text.css( 'min-height', 'auto' );
			$text.css( 'min-height', $text[ 0 ].scrollHeight + 'px' );
		}
	}

	jQuery( document ).on( 'gform_post_render', function() {
		const errorField = jQuery( '.contact-detail-cols' )[ 0 ]; // Convert jQuery object to native element

		if ( errorField ) {
			// Scroll to the error field
			scroller.scrollTo( errorField, {
				duration: 1.5,
				ease: 'linear',
				offsetY: 0,
			} );
		}
	} );

	if ( jQuery( window ).width() >= 1004 && jQuery( '.cursor' ).length ) {
		const cursor = jQuery( '.cursor' );
		jQuery( document ).on( 'mousemove', function( e ) {
			cursor.css( {
				left: e.clientX,
				top: e.clientY,
			} );
		} );
	}

	if ( jQuery( '.hero-home' ).length > 0 ) {
		const video = jQuery( '.hero-home' ).find( '.wp-block-video video' )[ 0 ];
		const muteIconButton = jQuery( '.hero-home' ).find( '.play-icon button.audio-icon' );
		const playIconButton = jQuery( '.hero-home' ).find( '.play-icon button.play-icon-btn' );

		muteIconButton.on( 'click', function() {
			if ( video.muted ) {
				video.muted = false;
				muteIconButton.addClass( 'unmute-video' );
			} else {
				video.muted = true;
				muteIconButton.removeClass( 'unmute-video' );
			}
		} );

		playIconButton.on( 'click', function() {
			if ( video.paused ) {
				video.play();
				playIconButton.removeClass( 'pause-video' );
			} else {
				video.pause();
				playIconButton.addClass( 'pause-video' );
			}
		} );
	}

	if ( jQuery( '.logos-area ' ).length > 0 ) {
		jQuery( '.logos-area' ).each( function() {
			gsap.to( this.querySelectorAll( '.column, .wp-block-column' ), {
				opacity: 1,
				y: '-20px',
				duration: 0.1,
				stagger: 0.05,
				ease: 'power2.out',
				scrollTrigger: {
					trigger: this,
					start: 'top 80%',
					toggleActions: 'play none none none',
					// markers: true,
				},
			} );
		} );
	}

	if ( jQuery( '.services-slider' ).length > 0 ) {
		const columns = jQuery( '.service-slide' );
		let maxHeight = 0;

		columns.each( function() {
			jQuery( this ).css( 'height', 'auto' );
			if ( jQuery( this ).outerHeight() > maxHeight ) {
				maxHeight = jQuery( this ).outerHeight();
			}
		} );

		columns.each( function() {
			jQuery( this ).css( 'height', maxHeight + 'px' );
		} );
	}

	if ( jQuery( window ).height() >= 867 && jQuery( window ).width() >= 1004 && jQuery( '.scrolling-services-container' ).length > 0 ) {
		const sliderOuter = jQuery( '.scrolling-services-container' );
		const slider = jQuery( '.services-slider-wrapper' );
		const slideWidth = jQuery( '.service-slide' ).outerWidth( true );
		const totalSlides = jQuery( '.service-slide' ).length;
		const totalWidth = slideWidth * totalSlides;
		const viewportWidth = sliderOuter.outerWidth();
		const topOffset = '-30px';

		gsap.to( '.scrolling-services-container', {
			scrollTrigger: {
				trigger: '.scrolling-services-container',
				start: `top ${ topOffset }`,
				end: () => `+=${ totalWidth }px`,
				scrub: 1,
				pin: true,
				pinSpacing: true,
			},
			ease: 'none',
		} );

		gsap.to( '.services-slider-wrapper', {
			x: () => -( totalWidth - viewportWidth + 610 ),
			ease: 'none',
			scrollTrigger: {
				trigger: '.scrolling-services-container',
				start: `top ${ topOffset }`,
				end: () => `+=${ totalWidth }px`,
				scrub: 1,
			},
		} );
	} else if ( jQuery( window ).height() <= 967 && jQuery( window ).width() >= 1004 && jQuery( '.scrolling-services-container' ).length > 0 ) {
		const sliderOuter = jQuery( '.services-slider' );
		const slider = jQuery( '.services-slider-wrapper' );
		const slideWidth = jQuery( '.service-slide' ).outerWidth( true );
		const totalSlides = jQuery( '.service-slide' ).length;
		const totalWidth = slideWidth * totalSlides;
		const viewportWidth = sliderOuter.outerWidth();
		const topOffset = '28%';

		gsap.to( '.services-slider-wrapper', {
			scrollTrigger: {
				trigger: '.services-slider',
				start: `top ${ topOffset }`,
				end: () => `+=${ totalWidth - viewportWidth }`,
				scrub: 1,
				pin: true,
				pinSpacing: true,
			// markers: true,
			},
			x: () => -( totalWidth - viewportWidth ),
			ease: 'none',
		} );
	}

	if ( jQuery( '.faq-block' ).length > 0 ) {
		jQuery( '.faq-block .faq-head' ).on( 'click keypress', function() {
			const currentFaq = jQuery( this );

			if ( currentFaq.hasClass( 'active' ) ) {
				currentFaq.removeClass( 'active' );
				currentFaq.parents().removeClass( 'active' );
				currentFaq.siblings( '.faq-content' ).slideUp( 400 );
			} else {
				jQuery( '.faq-block .faq-head' ).removeClass( 'active' );
				jQuery( '.faq-block .faq' ).removeClass( 'active' );
				jQuery( '.faq-block .faq-content' ).slideUp();

				currentFaq.addClass( 'active' );
				currentFaq.parents().addClass( 'active' );
				currentFaq.siblings( '.faq-content' ).slideDown( 400 );
			}
		} );
	}

	if ( jQuery( '.service-faqs' ).length > 0 ) {
		jQuery( '.service-faqs .faq-head' ).on( 'click keypress', function( e ) {
			if ( e.type === 'click' || ( e.type === 'keypress' && ( e.which === 13 || e.keyCode === 13 ) ) ) {
				const currentFaq = jQuery( this );

				if ( currentFaq.hasClass( 'active' ) ) {
					currentFaq.removeClass( 'active' );
					currentFaq.closest( '.faq' ).removeClass( 'active' );
					currentFaq.siblings( '.faq-content' ).slideUp( 400 );
				} else {
					jQuery( '.service-faqs .faq-head' ).removeClass( 'active' );
					jQuery( '.service-faqs .faq' ).removeClass( 'active' );
					jQuery( '.service-faqs .faq-content' ).slideUp();

					currentFaq.addClass( 'active' );
					currentFaq.closest( '.faq' ).addClass( 'active' );
					currentFaq.siblings( '.faq-content' ).slideDown( 400 );
				}
			}
		} );

		// Toggle behavior for .service-image
		jQuery( '.service-image' ).on( 'click', function() {
			const faq = jQuery( this ).closest( '.faq' );
			const faqHead = faq.find( '.faq-head' );
			const faqContent = faq.find( '.faq-content' );

			const isActive = faqHead.hasClass( 'active' );

			// Collapse all
			jQuery( '.service-faqs .faq-head' ).removeClass( 'active' );
			jQuery( '.service-faqs .faq' ).removeClass( 'active' );
			jQuery( '.service-faqs .faq-content' ).slideUp();

			if ( ! isActive ) {
				// Expand this one
				faqHead.addClass( 'active' );
				faq.addClass( 'active' );
				faqContent.slideDown( 400 );
			}
			// Else do nothing (it will remain collapsed)
		} );
	}

	if ( jQuery( '.ctn-top-shape' ).length > 0 || jQuery( '.ctn-bottom-shape' ).length > 0 ) {
		function animateShapes( selector ) {
			jQuery( selector ).each( function() {
				const $boxes = jQuery( this ).find( '.shape-box' );

				$boxes.each( function( index ) {
					gsap.from( jQuery( this ), {
						height: '0%',
						duration: 0.2,
						delay: index * 0.1,
						ease: 'none',
						scrollTrigger: {
							trigger: jQuery( this ).closest( selector ),
							start: 'top 80%',
						},
					} );
				} );
			} );
		}

		animateShapes( '.ctn-top-shape' );
		animateShapes( '.ctn-bottom-shape' );
	}

	if ( jQuery( window ).width() > 1004 ) {
		if ( jQuery( '.images-tiles-boxes' ).length > 0 ) {
			const boxesHeight = jQuery( '.images-tiles-boxes' ).outerHeight();
			const contentHeight = jQuery( '.images-tiles-content' ).outerHeight();
			const endValueOne = boxesHeight - contentHeight;
			const endValueTwo = contentHeight - boxesHeight;

			if ( boxesHeight > contentHeight ) {
				gsap.to( '.images-tiles-content', {
					scrollTrigger: {
						trigger: '.images-tiles-content',
						start: 'top 230',
						end: `+=${ endValueOne }px`,
						pin: true,
						scrub: 1,
						// markers: true,
					},
				} );
			} else {
				gsap.to( '.images-tiles-boxes', {
					scrollTrigger: {
						trigger: '.images-tiles-boxes',
						start: 'top 230',
						end: `+=${ endValueTwo }px`,
						pin: true,
						scrub: 1,
						// markers: true,
					},
				} );
			}
		}
	}

	if ( jQuery( '.stats-ctn' ).length > 0 ) {
		const $statNumbers = jQuery( '.stats-number' );

		function animateCounter( $element ) {
			const text = $element.text();
			const numericTextMatch = text.match( /[0-9.,]+/ );
			if ( ! numericTextMatch ) {
				return;
			}

			const numericText = numericTextMatch[ 0 ];
			const parts = text.split( numericText );
			const prefix = parts[ 0 ] || '';
			const suffix = parts[ 1 ] || '';

			const targetValue = parseFloat( numericText.replace( /,/g, '' ) );
			if ( isNaN( targetValue ) ) {
				return;
			}

			const startValue = 0;
			const duration = 1000;
			const totalFrames = duration / ( 1000 / 60 );
			const increment = ( targetValue - startValue ) / totalFrames;
			let animatedValue = startValue;

			const formatValue = ( value ) => Number.isInteger( targetValue ) ? Math.round( value ) : value.toFixed( 1 );

			const updateCounter = () => {
				animatedValue += increment;
				if ( animatedValue >= targetValue ) {
					$element.text( prefix + formatValue( targetValue ) + suffix );
				} else {
					$element.text( prefix + formatValue( animatedValue ) + suffix );
					requestAnimationFrame( updateCounter );
				}
			};
			requestAnimationFrame( updateCounter );
		}

		const isInViewport = ( element ) => {
			const rect = element[ 0 ].getBoundingClientRect();
			return rect.bottom >= 0 && rect.top <= ( window.innerHeight || document.documentElement.clientHeight );
		};

		jQuery( window ).on( 'scroll resize', () => {
			$statNumbers.each( function() {
				const $this = jQuery( this );
				if ( isInViewport( $this ) && ! $this.hasClass( 'animated' ) ) {
					animateCounter( $this );
					$this.addClass( 'animated' );
				}
			} );
		} ).trigger( 'scroll' );
	}

	if ( jQuery( '.intro-content' ).length > 0 && jQuery( window ).width() >= 1004 ) {
		const splitText = new SplitText( '.intro-content p', { type: 'chars,words' } );

		gsap.fromTo(
			splitText.chars,
			{ color: '#cccccc' },
			{
				color: '#000000',
				ease: 'none',
				stagger: 0.02,
				scrollTrigger: {
					trigger: '.intro-content',
					start: 'top 70%',
					end: 'bottom 70%',
					scrub: true,
				},
			}
		);
	}

	if ( jQuery( '.gallery-slider' ).length > 0 ) {
		let isPaused = false;
		const swiper = new Swiper( '.gallery-slider', {
			autoplay: {
				delay: 7000,
				disableOnInteraction: false,
			},
			slidesPerView: 'auto',
			spaceBetween: 20,
			autoHeight: true,
			// centeredSlides: true,
			loop: false,
			breakpoints: {
				640: {
					spaceBetween: 30,
				},
				768: {
					spaceBetween: 50,
				},
				1024: {
					spaceBetween: 60,
				},
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				renderBullet( index, className ) {
					return `<span class="${ className }" role="button" aria-label="Go to slide ${ index + 1 }">
                    <i></i><b class="progress-bar"></b>
                </span>`;
				},
			},
			on: {
				autoplayTimeLeft( s, time, progress ) {
					const activeBullet = document.querySelector( '.swiper-pagination-bullet-active .progress-bar' );
					if ( activeBullet ) {
						activeBullet.style.width = `${ ( 1 - progress ) * 100 }%`;
					}
				},
			},
		} );

		const playPauseBtn = document.createElement( 'button' );
		playPauseBtn.classList.add( 'swiper-play-pause' );
		playPauseBtn.setAttribute( 'aria-label', 'Pause slider' );
		document.querySelector( '.slider-controls' ).appendChild( playPauseBtn );

		playPauseBtn.addEventListener( 'click', () => {
			if ( isPaused ) {
				swiper.autoplay.resume();
				playPauseBtn.classList.remove( 'active' );
			} else {
				swiper.autoplay.pause();
				playPauseBtn.classList.add( 'active' );
			}
			isPaused = ! isPaused;
		} );
	}

	if ( jQuery( '.seo-slider' ).length > 0 ) {
		let isPaused = false;
		const swiper = new Swiper( '.seo-slider', {
			autoplay: {
				delay: 7000,
				disableOnInteraction: false,
			},

			slidesPerView: 'auto',
			spaceBetween: 20,
			autoHeight: true,
			breakpoints: {
				640: {
					spaceBetween: 24,
				},
				768: {
					spaceBetween: 40,
				},
				1024: {
					spaceBetween: 50,
				},
				1200: {
					spaceBetween: 64,
				},
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				renderBullet( index, className ) {
					return `<span class="${ className }" role="button" aria-label="Go to slide ${ index + 1 }">
                    <i></i><b class="progress-bar"></b>
                </span>`;
				},
			},
			on: {
				autoplayTimeLeft( s, time, progress ) {
					const activeBullet = document.querySelector( '.swiper-pagination-bullet-active .progress-bar' );
					if ( activeBullet ) {
						activeBullet.style.width = `${ ( 1 - progress ) * 100 }%`;
					}
				},
			},
		} );

		// Play/Pause Button Create & Append
		const playPauseBtn = document.createElement( 'button' );
		playPauseBtn.classList.add( 'swiper-play-pause' );
		playPauseBtn.setAttribute( 'aria-label', 'Pause slider' );
		document.querySelector( '.slider-controls' ).appendChild( playPauseBtn );

		// Function to Toggle Play/Pause
		playPauseBtn.addEventListener( 'click', () => {
			if ( isPaused ) {
				swiper.autoplay.resume(); // Resume swiper
				playPauseBtn.classList.remove( 'active' ); // Remove active class
			} else {
				swiper.autoplay.pause(); // Pause swiper
				playPauseBtn.classList.add( 'active' ); // Add active class
			}
			isPaused = ! isPaused;
		} );
	}

	jQuery( '.faqs .faq' ).each( function( index ) {
		jQuery( this ).find( '.faq-number' ).text( ( index + 1 ).toString().padStart( 2, '0' ) + '.' );
	} );

	jQuery( '.our-process-item .process-number' ).each( function( index ) {
		jQuery( this ).text( ( index + 1 ).toString().padStart( 2, '0' ) );
	} );

	if ( jQuery( '.member-slides-ltr' ).length > 0 || jQuery( '.member-slides-rtl' ).length > 0 ) {
		new Splide( '.member-slides-ltr', {
			type: 'loop',
			gap: 55,
			pagination: false,
			arrows: false,
			autoWidth: true,
			autoScroll: {
				speed: -1.5,
				pauseOnHover: false,
			},
			breakpoints: {
				1440: {
					gap: 40,
				},
				1280: {
					gap: 30,
				},
				900: {
					gap: 20,
				},
				480: {
					gap: 15,
				},
			},
		} ).mount( window.splide.Extensions );

		new Splide( '.member-slides-rtl', {
			type: 'loop',
			gap: 55,
			pagination: false,
			arrows: false,
			// perPage: 4.5,
			autoWidth: true,
			autoScroll: {
				speed: 1.5,
				pauseOnHover: false,
			},
			breakpoints: {
				1440: {
					gap: 40,
				},
				1280: {
					gap: 30,
				},
				900: {
					gap: 20,
				},
				480: {
					gap: 15,
				},
			},
		} ).mount( window.splide.Extensions );
	}

	// Social Shares

	const shareUrl = encodeURIComponent( window.location.href );
	const shareText = encodeURIComponent( document.title );

	jQuery( '.share-btn' ).on( 'click', function() {
		if ( jQuery( this ).hasClass( 'facebook' ) ) {
			window.open( `https://www.facebook.com/sharer/sharer.php?u=${ shareUrl }`, '_blank' );
		} else if ( jQuery( this ).hasClass( 'instagram' ) ) {
			// alert("Instagram does not support direct sharing. Please copy the link and share manually.");
			window.open( `https://www.instagram.com/`, '_blank' );
		} else if ( jQuery( this ).hasClass( 'linkedin' ) ) {
			window.open( `https://www.linkedin.com/shareArticle?url=${ shareUrl }&title=${ shareText }`, '_blank' );
		}
	} );

	// Check if .post-filter exists
	if ( jQuery( window ).width() < 747 && jQuery( '.post-filter' ).length ) {
		// setTimeout( () => {
		// Create a select element
		const $select = jQuery( '<select class="filter-dropdown"></select>' );

		// Append options from existing buttons
		jQuery( '.filter-bar button' ).each( function() {
			const text = jQuery( this ).text();
			const color = jQuery( this ).css( '--post_tag_color' );
			const isActive = jQuery( this ).hasClass( 'active' );
			const value = text.toLowerCase().replace( /\s+/g, '-' ); // Convert text to slug format

			const $option = jQuery( '<option></option>' )
				.text( text )
				.val( value )
				.css( '--post_tag_color', color );

			if ( isActive ) {
				$option.prop( 'selected', true );
			}

			$select.append( $option );
		} );

		// Replace button filter-bar with the select dropdown
		jQuery( '.filter-bar' ).replaceWith( $select );

		// Filter posts when select changes
		$select.on( 'change', function() {
			const selectedCategory = jQuery( this ).val();

			// Update category data attribute
			jQuery( '.post-filter' ).attr( 'data-selected-category', selectedCategory );

			// Show/Hide posts based on category
			if ( selectedCategory === 'all-work' ) {
				jQuery( '.post-box' ).show();
			} else {
				jQuery( '.post-box' ).hide();
				jQuery( '.post-box' ).filter( function() {
					return jQuery( this ).find( '.post-tag span' ).text().toLowerCase().replace( /\s+/g, '-' ) === selectedCategory;
				} ).show();
			}
		} );
		// }, 1000 );
	}

	// Accessibility work

	jQuery( '.has-font-size-5-font-size,.has-font-size-3-font-size,.leadership-col.member-text.col p' ).each( function() {
		jQuery( this ).attr( 'role', 'heading' ).attr( 'aria-level', '3' );
	} );

	jQuery( '.has-font-size-22-font-size' ).each( function() {
		jQuery( this ).attr( 'role', 'heading' ).attr( 'aria-level', '4' );
	} );

	jQuery( "[ tabindex = '0' ]" ).each( function() {
		const link = jQuery( this ).find( "[tabindex = '0']" );
		if ( link.length > 0 ) {
			jQuery( link ).removeAttr( 'tabindex' );
		} else {
			jQuery( link ).attr( 'tabindex', '0' );
		}
	} );

	if ( jQuery( window ).width() > 1004 ) {
		if ( jQuery( '.table-of-content-section' ).length > 0 ) {
			const headerHeightToc = jQuery( '.header-section' ).outerHeight();
			document.documentElement.style.setProperty( '--header-height-toc', `${ headerHeightToc }px` );
			const boxesHeightToc = jQuery( '.right-sidebar' ).outerHeight();
			const contentHeightToc = jQuery( '.left-sidebar' ).outerHeight();
			const endValueToc = boxesHeightToc - contentHeightToc;
			gsap.to( '.left-sidebar', {
				scrollTrigger: {
					trigger: '.left-sidebar',
					start: `top ${ headerHeightToc }`,
					end: `+=${ endValueToc }px`,
					pin: true,
					scrub: 1,
					// markers: true,
				},
			} );
		}

		if ( jQuery( '.table-of-content-section' ).length > 0 ) {
			const headings = jQuery( '.content-section-right h2' );
			const headingList = jQuery( '.heading-lists' );

			let count = 1;
			headings.each( function() {
				const id = jQuery( this ).text().trim().toLowerCase().replace( /[^a-zA-Z0-9 ]/g, '' ).replace( /\s/g, '-' );
				jQuery( this ).attr( 'id', id );

				if ( jQuery( this ).text() !== '' ) {
					const listItem = jQuery( '<li></li>' );
					const anchor = jQuery( '<a></a>' );
					anchor.attr( 'href', '#' + id ).html( jQuery( this ).text() );
					listItem.append( anchor );
					headingList.append( listItem );
					count++;
				}
			} );

			if ( headingList.html().trim() === '' ) {
				jQuery( '.table-of-content-list' ).hide();
				jQuery( '.sidebar-headings' ).hide();
			}
		}

		jQuery( ".left-sidebar a[href^='#']" ).on( 'click', function( e ) {
			e.preventDefault();
			const target = jQuery( this.getAttribute( 'href' ) );

			if ( target.length ) {
				let offset = 130;

				if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
					offset += 32;
				}
				jQuery( 'html, body' ).animate(
					{ scrollTop: target.offset().top - offset },
					100
				);
			}

			jQuery( '.heading-lists li a' ).removeClass( 'active' );
			jQuery( this ).addClass( 'active' );
		} );
	}

	jQuery( '.single-portfolio.postid-911 .hero-single h1.text-80' ).each( function() {
		const html = jQuery( this ).html();
		const updatedHtml = html.replace( /California/i, '<i class="first-character-capital">California</i>' );
		jQuery( this ).html( updatedHtml );
	} );

	if ( jQuery( '.quote-slider' ).length > 0 ) {
		new Swiper( '.quote-slider', {
			slidesPerView: 1,
			slidesPerGroup: 1,
			pagination: {
				el: '.quote-slider .swiper-pagination',
				clickable: true,
			},
		} );
	}
} );

